import React from "react";

interface PokemonInputProps {
  isNextPokemonButtonShowing: boolean;
  handleSubmit: Function;
  guessText: string;
  setIsGameOver: Function;
}

const PokemonInput = ({
  isNextPokemonButtonShowing,
  handleSubmit,
  guessText,
  setIsGameOver,
}: PokemonInputProps) => {
  return (
    <div className="w-full">
      <div>
        {isNextPokemonButtonShowing ? (
          <h1 className="text-3xl font-bold">Nice job!</h1>
        ) : (
          <>
            <input
              type="text"
              aria-label="pokemon-input"
              autoFocus
              placeholder="Enter Pokemon name"
              hidden={isNextPokemonButtonShowing}
              className="my-4 rounded-xl px-4 py-2 border border-gray-300"
              value={guessText}
              onChange={(e) => {
                console.log("Calling handle submit!");
                handleSubmit(e.target.value);
              }}
            />
            <button
              className="ml-4 px-4 py-2 bg-gray-200 hover:bg-gray-300 rounded"
              onClick={() => {
                setIsGameOver(true);
              }}
            >
              Give up?
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default PokemonInput;
